import { Radio, RadioGroup } from "@headlessui/react";
import { capitalize } from "lodash";
import React from "react";

const PlansFrequency = ({ frequency, setFrequency }) => {
  return (
    <fieldset aria-label="frequency">
      <RadioGroup
        value={frequency}
        onChange={setFrequency}
        className="grid grid-cols-2 gap-x-1 rounded-lg p-1 text-center text-xs/5 font-semibold ring-1 ring-inset ring-gray-200 bg-[#fafafa]"
      >
        {["monthly", "annually"].map(option => (
          <Radio
            key={option}
            value={option}
            className="cursor-pointer rounded-lg px-2.5 py-1 text-gray-700 data-[checked]:bg-white data-[checked]:text-gray-900"
          >
            <span>{capitalize(option)}</span>
            {option === "annually" && (
              <span className="ml-2 inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-800 ring-1 ring-inset ring-gray-500/10">
                20% off
              </span>
            )}
          </Radio>
        ))}
      </RadioGroup>
    </fieldset>
  );
};

export default PlansFrequency;
